module.exports = "data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAAUoAAAFKAQMAAABB54RGAAAABlBMVEX///8AAABVwtN+AAABVklEQVRoge3ZTa7DIAwEYKQcIEfi6hwpB3jSvOKfYJVUXdqVZhZJW76uKI6hrTEMwzDMrwWWv4YhH5yAXDSDtBQ1IPTQMYzX2zhKWobOSZxjwHUrebsmm7QgRfSkpWnrSg+Q1qVy8zHLt/pKmkRDQ3Kuy7fehTSFxnjn+GGYNJ3qM01X4GlVUhrJVw3dfgOkyVS9jEn65R3/fNi9Q9Jsei++rrMLp+uJR1qJatMYtmaypd7LJ2k27dfd8etatHr5UDRJsyngn/jZh5XKUEhJq1DL6u7DAfBWNEnTqZx4XPLS51RrKPb6SppLw6mUXtrhc/w+saTpNHxpzKs+8dpqTUgL0TCJfe2mTzu4Jy1Gh9zCMvSJnSGtRv3PFZ3gWz0sQ9I6VOul/nuJx60ZaSUKP6mSV23bxZHmU7n5Mw3rpB74XF9Jk6jF+3yj8SiYtAxlGIZhmN/IPw6zGk8WObcMAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/app-qrcode.jpg
// module id = 431
// module chunks = 0